import { Injectable , OnDestroy } from '@angular/core';
import { IdataBinding } from '@ispm-client/modules/aggregator/interfaces';
import { AgregationService, FlattenService } from '@ispm-client/modules/aggregator/services/index';
import { takeUntil } from 'rxjs/operators';
import { isEqual, cloneDeep, remove } from 'lodash';
import { Subject, Observable } from 'rxjs/index';
import { DataBindingHandlerService } from "@ispm-client/modules/aggregator/services/dataBindingHandler.service";


@Injectable()
export  class QueryRegistrationTransformationService implements OnDestroy {

  private destroyer: Subject<any> = new Subject();
  private dataob$: Subject<any> = new Subject();
  private entityTreeData: Map<string, any> = new Map<string, any>();

  constructor(protected _queryAgregator: AgregationService,
              public flattenService: FlattenService,
              protected dataBindingHandler : DataBindingHandlerService) {

  }

       public  queryRegistration(dataBindings: IdataBinding[]) : Observable<any> {
             let firstIteration = true;
             const actualPrefetch = this.dataBindingHandler.findPreFetch(dataBindings);
             this._queryAgregator.registerQuery(actualPrefetch)
             /** Using filter below to avoid repainting the dynamic form if data was
              * same as what it recieved last time
              */
               .filter((val ) => !(isEqual(Object.entries(Object.assign({ }, ...val)), this.entityTreeData))).
             pipe(takeUntil(this.destroyer.asObservable()))
               .subscribe((data) => {
                 /** Not sure whether observable should be returned directly/Assining the form itself here
                  As from array to object same identifier data will be lost
                  Achieving distinct via varibale should do it differently
                  */
                 const responseData = Object.assign({ }, ...cloneDeep(data));
                 this.entityTreeData = new Map(Object.entries(responseData)); // this field can also be used later to get meta and id info of all
                 const resultInterpolateAndFetch = this.dataBindingHandler.findDependantsExcludingPickerIdentifierPath(dataBindings);
                 if (resultInterpolateAndFetch.length > 0) {
                   if (firstIteration) {
                     firstIteration = false;
                     this.interpolateAndRegister(resultInterpolateAndFetch, responseData, false);
                   } else {
                     this.dataob$.next(responseData);
                     this.retriggerDepandant(actualPrefetch, resultInterpolateAndFetch, responseData);
                   }

                 } else {
                     this.dataob$.next(responseData);
                 }
               });

             return this.dataob$.asObservable();
           }



  private interpolateAndRegister(dataBindings: Array < IdataBinding > , interpolateData: any, triggerDependant: boolean) {
    let interpolatedQueryString;
    // Passing the patient context also as during interpolation if interpolation data is not available it is set as Object object
    interpolateData = cloneDeep(Object.assign({ }, this._queryAgregator.getPatientContextId(), interpolateData));
    dataBindings.forEach(data => {
      data.queryString = this._queryAgregator.interpolate(data.queryString, interpolateData);
      interpolatedQueryString = data.queryString;
      if ((data.additionalFields) && (!(interpolatedQueryString.includes('&_fieldslist=')))) {
        interpolatedQueryString += '&_fieldslist=' + data.additionalFields;
      }
      data.interpolatedQuery = interpolatedQueryString;
    });
    //this._queryAgregator.setPolatedDatabindings(dataBindings);
    /**
     * TODO Should not compare with enityTreeDatashould check whether
     * need to check enityTreeData has val and same
     */
    this._queryAgregator.ondemandRegister(dataBindings, triggerDependant).filter
    (val => !(isEqual(Object.entries(Object.assign({ }, ...val)), this.entityTreeData)))
      .pipe(takeUntil(this.destroyer.asObservable()))
      .subscribe((data) => {
        const oldObj = Array.from(this.entityTreeData).reduce((obj, [key, value]) => {
          obj[key] = value;
          return obj;
        }, { });
        const finalObj  = Object.assign({ }, oldObj, ...cloneDeep(data));
        this.entityTreeData = new Map(Object.entries(finalObj));

        this.dataob$.next(finalObj);
      });
  }


    private retriggerDepandant(_feederDatabindings: Array<IdataBinding>, _depandantDatabindings: Array<IdataBinding>, _interpolateObj: any) {
      const retriigerDepandants = this._queryAgregator.getretriggerDatabindings();
      if (retriigerDepandants.inArray(function (e) {
          return e.identifier === _feederDatabindings[0].identifier;
        })) {
        this.interpolateAndRegister(_depandantDatabindings, _interpolateObj, true);
        remove(retriigerDepandants, function (binding:IdataBinding) {
          return binding.identifier === _feederDatabindings[0].identifier;
        });
       // this._queryAgregator.setretriggerDatabindings(retriigerDepandants);
      }

    }

  ngOnDestroy () {
    this.destroyer.next();
    this.destroyer.complete();
  }
}
